/**
 * ErrorBoundary — Catches React render errors and displays a friendly fallback UI.
 */

import React from 'react';
import './ErrorBoundary.css';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console (could be extended to an error reporting service)
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="eb-container">
          <div className="eb-card">
            <h1 className="eb-title">Something went wrong</h1>
            <p className="eb-message">
              An unexpected error occurred. Don't worry — your data is safe. Try reloading the page, or go back to the home page.
            </p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="eb-details">
                <summary>Error Details (dev only)</summary>
                <pre className="eb-stack">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="eb-actions">
              <button className="eb-btn eb-btn-primary" onClick={this.handleReload}>
                Reload Page
              </button>
              <button className="eb-btn eb-btn-secondary" onClick={this.handleGoHome}>
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
